import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Api } from '../../services/api';
import { Globals } from '../../services/globals';

@Component({
    selector: 'barcode-tester',
    templateUrl: './barcode-tester.component.html',
    styleUrls: ['./barcode-tester.component.scss'],
    standalone: false
})
export class BarcodeTesterComponent {
    sku?: string;
    barcode?: string;
    result?: string;

    constructor(private api: Api, private router: Router, private route: ActivatedRoute, private globals: Globals) {

    }

    async ngOnInit() {

    }

    async inputChanged(){

    }

    async testBarcode() {
        let result = await this.api.store().post<any>(`/test-barcode`, { barcode: this.barcode, sku: this.sku });
        this.result = JSON.stringify(result, null, 2);
    }



}
